module.exports = __webpack_public_path__ + "images/category_lp/pc/flag_7a6aeadc7c5487e777327d91f292c6dc.png";